import { getOfferType } from './offerExportColumns'

export const formatDiscount = (discount) => {
  const scheme = discount?.scheme
  const amount = scheme?.amount
  if (amount === undefined || amount === null) {
    return ''
  }
  switch (scheme.typeName) {
    case 'PercentOff':
      return `${amount}% off`
    case 'FixedAmount':
      return `$${amount} off`
    default:
      return ''
  }
}

export const getOfferDetailsValue = (row) => {
  const type = getOfferType(row.discount)
  let base
  if (row.source?.type?.toLowerCase() === 'shopify') {
    base = 'Shopify'
  } else if (type.key === 'codePool') {
    base = 'Code Pool'
  } else {
    base = type.name
  }
  const discount = formatDiscount(row.discount)
  return discount ? `${base} — ${discount}` : base
}
